// Central schema registry for the offline IndexedDB database.
// To add a new store: add an entry to STORES (and STORE_NAMES) and bump DB_VERSION.

import AppSettings from "../AppSettings";

export const DB_NAME = "actonOfflineDB";

// Bump this whenever STORES changes (new store, new index, changed keyPath).
export const DB_VERSION = AppSettings.indexedDBVersion;

export const STORE_NAMES = {
    // Date-wise cache of GetDayMealRoutes responses. Key = "YYYY-MM-DD".
    MEALS_BY_DATE: "mealsByDate",
    // Generic offline mutation queue (outbox) for action APIs made while offline.
    OUTBOX: "outbox",
};

// Each store: { name, options (createObjectStore opts), indexes: [{ name, keyPath, options }] }
export const STORES = [
    {
        name: STORE_NAMES.MEALS_BY_DATE,
        options: { keyPath: "date" },
        indexes: [
            { name: "updatedAt", keyPath: "updatedAt", options: { unique: false } },
        ],
    },
    {
        name: STORE_NAMES.OUTBOX,
        options: { keyPath: "id" },
        indexes: [
            { name: "status", keyPath: "status", options: { unique: false } },
            { name: "createdAt", keyPath: "createdAt", options: { unique: false } },
            { name: "dedupeKey", keyPath: "dedupeKey", options: { unique: false } },
        ],
    },
];
